import { ValidationError } from './ValidationError';

// TS Placeholders
type Instruction = any; // vse/machinelogic/Instruction.js
/**
 * handle missing sequences
 */
export function validateSequences(pInstruction: Instruction, pAppName: string, pSequenceName: string, pInstructionIndex: number): ValidationError[] {
  let lSequence;

  if ('if' === pInstruction.mName) {
    lSequence = pInstruction.getParameter('conditions').map(
      function (pEl, pIndex) { return { name: pEl.sequenceName, index: pIndex }; });
  } else if ('fsm' === pInstruction.mName) {
    lSequence = pInstruction.getParameter('states').map((pState) => {
      return { stateName: pState.stateName ,name: pState.actionSequenceName, index: 0 }; // [oliver levy]: not sure if I like this. Since the fsm has multiple states and multiple sequences, I'm not able to show where to fix the error in the ui.
    });
  } else {
    lSequence = [{ name: pInstruction.getParameter('sequenceName'), index: 0 }];
  }

  if (!lSequence) { return []; }

  const lMissingSequences = lSequence.filter(function (pSequence) {
    if(pSequence.name === '') {
      return false; // for the scenario where the sequence name is allowed to be emtpy
    }
    return pInstruction.mApp.mSequences.every(function (pSeq) { return pSeq.mName !== pSequence.name;});
  });

  if (0 === lMissingSequences.length) { return []; }

  return lMissingSequences.map(function (pEl) {
    const options = [{ message: 'Create a Sequence in the left pane.', target: 'redirect-sequence' }];

    // only propose to select a sequence if there is more then 1 sequences and we are not the only child sequence
    const pApp = pInstruction.mApp;
    const pSeq = pInstruction.mSequence;
    const lHasNotEnoughSequences = pApp.listSequences().length == 1 || (pApp.listSequences().length == 2 && pApp.getInitialSequence().getName() != pSeq.getName());
    if (!lHasNotEnoughSequences) { options.unshift({ message: 'Select a Sequence from the drop down menu.', target: `${pEl.index}.sequenceName` }); }

    let header;
    let message;
    switch(pInstruction.mName) {
      case 'fsm':
        header = 'Missing associated state action';
        message = `"${pSequenceName}" → command #${pInstructionIndex}, missing action in state: "${pEl.stateName}"`;
        break;
      default:
        header = 'Missing associated Sequence.';
        message = `"${pSequenceName}" → command #${pInstructionIndex}, missing  sequence named: "${pEl.name}"`;
    }

    return {
      header: header,
      onError: {
        message: message,
        options: options
      },
      onSuccess: {
        message: 'The Sequence is not missing anymore.'
      },
      instructionSubResource: pEl.index
    };
  });
}
